<script>
import Vue from "vue";
import VuePlyr from 'vue-plyr/src/vue-plyr.vue'
import 'vue-plyr/dist/vue-plyr.css'
import { Swipe, SwipeItem } from 'vant'


Vue.nextTick(() =>
{
  //
  setTimeout(() =>
  {
    let playerEl = document.querySelector('#player')
    if (playerEl === null || playerEl === undefined)
    {
      console.log(playerEl, "playEl 没有视频")
      return
    }
    let player = playerEl.plyr
    console.log("nextTick: 播放事件已修复")
    document.querySelector(".plyr__video-wrapper").addEventListener("click", event =>
    {
      player.togglePlay();
    });

  }, 3000)
})
export default {
  name: "SwipeImgAndVideo",
  functional: true,
  render(h, context)
  {
    const { goodsDetail, current } = context.props
    const goodsImages = goodsDetail.goodsImages
    const genPlayerVnode = (goodsImage, posteUrl) =>
    {
      console.log("genPlayerVnode posteUrl", posteUrl)
      return h(VuePlyr, {
        enabled: true,
        attrs: { id: "player" },
        props: {
          options: {
            fullscreen: { enabled: true, fallback: true, iosNative: true, container: '#app' },
            type: 'video',
            // clickToPlay: true,
            muted: true,
            controls: ['play-large', 'play', 'progress', 'mute', 'volume', 'fullscreen'],
            // controlls:['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen'],
            // controls: controls,
            listeners: {
              play(e)
              {
                console.log('play', e)
              },
            }

          },

        },
      }, [
        h("video", {
          attrs: {
            width: '390',
            height: '390',
            preload: 'preload',
            "data-poster": posteUrl,
            // poster: "https://cup2.oss-cn-hangzhou.aliyuncs.com/mw2HnR8OvNDWJCKBsNYr5.jpg"
            poster: posteUrl,
          },
          style: { "max-height": "390px" },
        }, [
          h("source", {
            attrs: {
              src: goodsImage.url,
            }
          })
        ])

      ])

    }

    function genSwipeItems()
    {
      if (!(goodsImages === undefined))
      {

        let posteUrl = '';
        if (goodsImages.length > 1)
        {
          posteUrl = goodsImages[1].url
        }
        return goodsImages.map((goodsImage, idx) =>
        {
          let child = goodsImage.isVideo ?
            genPlayerVnode(goodsImage, posteUrl) : h("img", {
              attrs: {
                src: goodsImage.url
              }, class: {
                "w-full": true
              }
            })
          if (goodsImage.isVideo)
          {
            // console.log(child, "child");
          }

          return h(SwipeItem, {
            style: { "max-height": "390px" },
            props: {
              // 当前 SwipeItem 的索引
              index: idx,
              key: idx
            }
          }, [child])
        })
      } else
      {
        return [h(SwipeItem, null, [])]
      }
    }
    function genSwipSlot()
    {
      if (goodsImages === undefined)
      {
        return {
          default: function (props) { return [...genSwipeItems()] }
        }
      } else
      {
        // 实现 Swipe 的插槽属性生成
        return {
          default: function (props) { return [...genSwipeItems()] },
          indicator: function (props)
          {
            // console.log(props, "props");
            return h("div", {
              class: {
                "custom-indicator": true
              }
            }, [
              current + 1,
              "/",
              goodsImages.length
            ])
          }
        }
      }
    }
    return h(Swipe,
      {
        on: context.data.on,
        scopedSlots: genSwipSlot()
      }, [...genSwipeItems()])
  },
}
</script>

<style lang="less">
:root {
  --plyr-color-main: #c90000;
}
</style>
